import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-distributed-surveys',
  template: require('./distributed-surveys.component.html')
})
export class DistributedSurveysComponent extends BaseComponent implements OnInit {

  public surveyId = -1;

  public distributedSurveys = [];

  public survey = {
    title:""
  };

  public surveyPercentage(s) {
    var perct = 0;
    perct = s.employeeCompletedCount / s.employeeCount * 100;
    return perct;
  }


  public getSurveySuspendText(survey) {

    if(survey.suspendSurvey == 0 && survey.suspendAnySurvey == 1) {
      return "Few Survey(s) Stopped";
    }
    else if(survey.suspendSurvey==1){
      return "All Survey(s) Stopped";
    }
    else {
      return "";
    }

  }

  public routeParamsUpdated() {
    this.surveyId = this.default(this.currentRouteParams["surveyId"],-1);
    if(this.surveyId>0) {
     this.loadSurveyById();
    }
    else 
      this.surveyId = -1;
  }


  public loadSurveyById() {
    this.busy = this.lsApi.getSurveyById(this.surveyId).subscribe(resp => {
        if(resp.status) {
            this.survey = resp.data[0];
            this.loadDistributedSurveys();
        }
    },
    error => {
        console.log(error);
    });
  }

  public loadDistributedSurveys() {
    this.busy = this.lsApi.getDistributedSurveysBySurveyId(this.surveyId).subscribe(resp => {
        if(resp.status) {
            this.distributedSurveys = resp.data;
        }
    },
    error => {
        console.log(error);
    });
  }

  ngOnInit() {
    super.ngOnInit();
  }

  public stopSurvey(s) {

  }

  public deleteSurvey(s) {

  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/distributed-surveys/distributed-surveys.component.ts